import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {BinExtModel} from '../../../../../../models/aggregates/erp/stock';
import {Core2Config} from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class BinExtService extends BaseApiTemplateService<BinExtModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'bin-ext';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'bin-ext';
    this.endpoint_path = Core2Config.DOMAIN_URL_PREFIX + 'bin-ext';
    this.httpClient = http;
  }

}


